module.exports = "/_next/static/images/philadelphia-a13f9fb6e0c05bd6994ea15db0bd651b.jpg.webp";